;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.11";import * as Sentry from "@sentry/nextjs";

const SENTRY_ENABLED = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-enabled"]',
)?.content;
const ENVIRONMENT = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-env"]',
)?.content;
const SENTRY_RELEASE_NAME = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-release-name"]',
)?.content;
const SENTRY_RELEASE_VERSION = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-release-version"]',
)?.content;
const BUILD_ID = document.querySelector<HTMLMetaElement>(
  'meta[name="build-id"]',
)?.content;

const SENTRY_DSN =
  "https://233f6838d889058a37a72204d2bbf0e4@o77844.ingest.us.sentry.io/4511433349857280";

Sentry.init({
  enabled: SENTRY_ENABLED === "true",
  sampleRate: 0.25,
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,
  release: `${SENTRY_RELEASE_NAME}@${SENTRY_RELEASE_VERSION}`,
  dist: BUILD_ID,
  integrations: [
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration(),
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
